import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import ErrorBoundaryRoute from "../../../../containers/ErrorBoundaryRoute";
import Object from './components/Checkout';

export default ({match, locations, account, shouldReloadCart, scannedCode, auto_cc_fee, apply_cc_fee_to_debit, posLocation}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute path={`${match.url}`}>
				<Object
					locations={locations}
					account={account}
					baseUrl={`${match.url}`}
					shouldReloadCart={shouldReloadCart}
					scannedCode={scannedCode}
					auto_cc_fee={!!auto_cc_fee}
					apply_cc_fee_to_debit={apply_cc_fee_to_debit == null ? true : !!apply_cc_fee_to_debit}
					posLocation={posLocation}
				/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
